import { Language } from 'types/language'
import TermsDutch2023 from './content/11092023/TermsDutch'
import TermsFrench2023 from './content/11092023/TermsFrench'
import TermsDutch2025 from './content/14022025/TermsDutch'
import TermsFrench2025 from './content/14022025/TermsFrench'
import dayjs from 'dayjs'
import { OldTermsVersions } from './types'

export const OLD_TERMS_VERSIONS: OldTermsVersions = {
  '2023-09-01': {
    [Language.DUTCH]: <TermsDutch2023 />,
    [Language.FRENCH]: <TermsFrench2023 />
  },
  '2025-02-14': {
    [Language.DUTCH]: <TermsDutch2025 />,
    [Language.FRENCH]: <TermsFrench2025 />
  }
}
export const SORTED_OLD_TERMS_KEYS = Object.keys(OLD_TERMS_VERSIONS).sort((a, b) => dayjs(b).diff(dayjs(a)))
